import React from 'react'

import Collapsible from "react-collapsible";

import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";

import Border from "./Border";
import Toggle from "./sectioninputs/Toggle";
import Dropdown from "./Dropdown";
import {renderDragIcon} from "../utils/renderDragIcon.js"

const CART_DRAWER_BUTTON_STYLES = [
  {
    value: "primary",
    label: "Primary"
  },
  {
    value: "secondary",
    label: "Secondary"
  },
]

export default class DrawerCartSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
    }

  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderCheckoutButtonSettings(){
    let { data } = this.state

    let showCheckoutButtonInCartDrawer = data.cart_drawer_checkout ?? true
    let checkoutButtonStyle = data.cart_drawer_checkout_style || "primary"

    return (
      <>
        <Collapsible
          className={"drawer-cart-settings"}
          openedClassName={"drawer-cart-settings"}
          key={"key_+"+showCheckoutButtonInCartDrawer}
          trigger={
            <>
              {renderDragIcon({}, "absolute")}
              <Toggle
                id="checkout_toggle"
                checked={showCheckoutButtonInCartDrawer}
                title="Checkout Button"
                onChange={checked => {
                  data.cart_drawer_checkout = checked
                  this.props.onUpdated(data)
                }}
              />
            </>
          }
        >
          <br/>
          <span>
            Checkout Button Style
          </span>
          <Dropdown
            options={CART_DRAWER_BUTTON_STYLES}
            value={CART_DRAWER_BUTTON_STYLES.find((style) => style.value === checkoutButtonStyle)}
            onChange={option => {
              data.cart_drawer_checkout_style = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Checkout Button Style"
          />
        </Collapsible>
      </>
    )
  }

  _renderViewCartButtonSettings(){
    let { data } = this.state

    let showViewCartButtonInCartDrawer = data.cart_drawer_view_cart ?? false
    let viewCartButtonStyle = data.cart_drawer_view_cart_style || "primary"

    return (
      <>
        <Collapsible
          className={"drawer-cart-settings"}
          openedClassName={"drawer-cart-settings"}
          key={"key_+"+showViewCartButtonInCartDrawer}
          trigger={
            <>
              {renderDragIcon({}, "absolute")}
              <Toggle
                id="view_cart_toggle"
                checked={showViewCartButtonInCartDrawer}
                title="View Cart Button"
                onChange={checked => {
                  data.cart_drawer_view_cart = checked
                  this.props.onUpdated(data)
                }}
              />
            </>
          }
        >
          <br/>
          <span>
            View Cart Button Style
          </span>
          <Dropdown
            options={CART_DRAWER_BUTTON_STYLES}
            value={CART_DRAWER_BUTTON_STYLES.find((style) => style.value === viewCartButtonStyle)}
            onChange={option => {
              data.cart_drawer_view_cart_style = option.value
              this.props.onUpdated(data)
            }}
            placeholder="View Cart Button Style"
          />
        </Collapsible>
      </>
    )
  }

  _renderContinueShoppingButtonSettings(){
    let { data } = this.state

    let showContinueShoppingButtonInCartDrawer = data.cart_drawer_continue_shopping ?? true
    let continueShoppingButtonStyle = data.cart_drawer_continue_shopping_style || "secondary"

    return (
      <>
        <Collapsible
          className={"drawer-cart-settings"}
          openedClassName={"drawer-cart-settings"}
          key={"key_+"+showContinueShoppingButtonInCartDrawer}
          trigger={
            <>
              {renderDragIcon({}, "absolute")}
              <Toggle
                id="continue_shopping_toggle"
                checked={showContinueShoppingButtonInCartDrawer}
                title="Continue Shopping Button"
                onChange={checked => {
                  data.cart_drawer_continue_shopping = checked
                  this.props.onUpdated(data)
                }}
              />
            </>
          }
        >
          <br/>
          <span>
            Continue Shopping Button Style
          </span>
          <Dropdown
            options={CART_DRAWER_BUTTON_STYLES}
            value={CART_DRAWER_BUTTON_STYLES.find((style) => style.value === continueShoppingButtonStyle)}
            onChange={option => {
              data.cart_drawer_continue_shopping_style = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Continue Shopping Button Style"
          />
        </Collapsible>
      </>
    )
  }

  _onDragEnd(result, unorderedItems) {
    let { data } = this.state

    if (!result.destination) {
      return;
    }

    const items = reorder(
      unorderedItems,
      result.source.index,
      result.destination.index
    );

    items.forEach((item, index) => {
      data[item.key] = index
    })

    this.props.onUpdated(data)
  }

  render() {

    let { data } = this.state

    const buttons = [
      {
        key: "cart_drawer_checkout_position",
        position: data.cart_drawer_checkout_position ?? 0,
      },
      {
        key: "cart_drawer_view_cart_position",
        position: data.cart_drawer_view_cart_position ?? 1,
      },
      {
        key: "cart_drawer_continue_shopping_position",
        position: data.cart_drawer_continue_shopping_position ?? 2,
      }
    ]

    const orderedButtons = [...buttons].sort((a, b) => a.position - b.position);

    return (
      <>
        <Border>
          <Collapsible
            trigger={`Drawer Cart Buttons`}
          >
            <br/>
            <DragDropContext onDragEnd={(result) => this._onDragEnd(result, orderedButtons)}>
              <Droppable droppableId="cart-drawer-settings">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {
                      orderedButtons.map((button, index) => (
                        <Draggable key={button.key} draggableId={button.key} index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {button.key === "cart_drawer_checkout_position" && this._renderCheckoutButtonSettings()}
                              {button.key === "cart_drawer_view_cart_position" && this._renderViewCartButtonSettings()}
                              {button.key === "cart_drawer_continue_shopping_position" && this._renderContinueShoppingButtonSettings()}
                            </div>
                          )}
                        </Draggable>
                      ))
                    }
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Collapsible>
        </Border>
      </>
    )
  }
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 0;

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#fbfbfb" : "transparent",
  padding: grid,
});

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: grid,
  background: isDragging ? "rgba(93, 120, 255, 0.4)" : "transparent",
  outline: "none",
  ...draggableStyle,
});
